import { useEffect, useState } from "react";
import { getApi } from "../utils/api.ts";
import { API_LEAVE_TODAY } from "../../config/Endpoints.js";
import Cookies from "js-cookie";
import { formatLocalDate } from "../utils/helpers.ts";

export function useTodayLeaves(selectedDate?: Date) {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const token = Cookies.get("accessToken");

  useEffect(() => {
    const fetchLeaves = async () => {
      try {
        setLoading(true);
        const dateToUse = selectedDate ?? new Date();
        const formattedDate = formatLocalDate(dateToUse);

        const res = await getApi<{ data: any[] }>(
          `${API_LEAVE_TODAY}?date=${formattedDate}`,
          token,
        );

        setData(res.data.data || []);
      } catch {
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaves();
  }, [selectedDate, token]);

  return { data, loading };
}
